$(window).on("load",function(){
  // our collections slider
  $('.collection_slider').slick({
    infinite: true,
    dots: false,
    slidesToShow: 3.,
    slidesToScroll: 1,
    appendArrows: '.collection_Arrows',
    prevArrow: "<div class='pre-btn'><svg width='26' height='25' viewBox='0 0 26 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M26 13.7233L3.50706 13.7233L13.1469 23.3631L11.935 24.7402L0 12.8052L11.935 0.870176L13.1469 2.2473L3.50706 11.8871L26 11.8871V13.7233Z' fill='black'/></svg></div>",
    nextArrow: "<div class='next-btn'><svg width='26' height='24' viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0 12.8532L22.4929 12.8532L12.8531 22.493L14.065 23.8701L26 11.9351L14.065 5.91278e-05L12.8531 1.37718L22.4929 11.017L0 11.017V12.8532Z' fill='black'/></svg></div>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
       
  // best seller slider
  $('.bestesller_prod').slick({
    infinite: true,
    dots: false,
    slidesToShow: 4.,
    slidesToScroll: 1,
    appendArrows: '.bestesller_Arrows',
    prevArrow: "<div class='pre-btn'><svg width='26' height='25' viewBox='0 0 26 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M26 13.7233L3.50706 13.7233L13.1469 23.3631L11.935 24.7402L0 12.8052L11.935 0.870176L13.1469 2.2473L3.50706 11.8871L26 11.8871V13.7233Z' fill='black'/></svg></div>",
    nextArrow: "<div class='next-btn'><svg width='26' height='24' viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0 12.8532L22.4929 12.8532L12.8531 22.493L14.065 23.8701L26 11.9351L14.065 5.91278e-05L12.8531 1.37718L22.4929 11.017L0 11.017V12.8532Z' fill='black'/></svg></div>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
        
  // testimonial slider
  $('.testimonal-slider').slick({
    infinite: true,
    dots: true,
    slidesToShow: 3.,
    slidesToScroll: 1,
    appendArrows: '.testi_Arrows',
    prevArrow: "<div class='pre-btn'><svg width='26' height='25' viewBox='0 0 26 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M26 13.7233L3.50706 13.7233L13.1469 23.3631L11.935 24.7402L0 12.8052L11.935 0.870176L13.1469 2.2473L3.50706 11.8871L26 11.8871V13.7233Z' fill='black'/></svg></div>",
    nextArrow: "<div class='next-btn'><svg width='26' height='24' viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0 12.8532L22.4929 12.8532L12.8531 22.493L14.065 23.8701L26 11.9351L14.065 5.91278e-05L12.8531 1.37718L22.4929 11.017L0 11.017V12.8532Z' fill='black'/></svg></div>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  // collection page left side dropdown
  $("ul#categories-cls li.nav--has-dropdown span.arrow").on("click", function () {
    $(this).parent("li").hasClass("liactive") == !1 
    ? ($("ul#categories-cls li.nav--has-dropdown span.arrow").removeClass("active").siblings("ul").slideUp().parent("li").removeClass("liactive"),
    $(this).addClass("active").siblings("ul").slideDown().parent("li").addClass("liactive"),
    $(this).html("<svg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13.9999 6.67262C14.0004 6.50185 13.9675 6.33312 13.9034 6.17883C13.8394 6.02454 13.746 5.88861 13.63 5.78103L7.63053 0.260033C7.45162 0.0919093 7.22719 -9.28495e-08 6.99559 -8.9874e-08C6.76399 -8.68986e-08 6.53957 0.0919093 6.36065 0.260033L0.361218 5.97535C0.157021 6.16937 0.0286086 6.44818 0.00423118 6.75043C-0.0201462 7.05269 0.061508 7.35363 0.231231 7.58707C0.400953 7.8205 0.644841 7.9673 0.909243 7.99516C1.17364 8.02303 1.4369 7.92969 1.6411 7.73566L7.00059 2.62617L12.3601 7.5642C12.5069 7.70398 12.6856 7.79277 12.8751 7.82007C13.0646 7.84736 13.257 7.81202 13.4296 7.71823C13.6021 7.62443 13.7475 7.47611 13.8485 7.29081C13.9496 7.1055 14.0022 6.89098 13.9999 6.67262Z' fill='#D9D9D9'/></svg> "))
    : ($("ul#categories-cls li.nav--has-dropdown span.arrow").removeClass("active").siblings("ul").slideUp().parent("li").removeClass("liactive"), $(this).html("<svg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13.9999 1.32738C14.0004 1.49815 13.9675 1.66688 13.9034 1.82117C13.8394 1.97546 13.746 2.11139 13.63 2.21897L7.63053 7.73997C7.45162 7.90809 7.22719 8 6.99559 8C6.76399 8 6.53957 7.90809 6.36065 7.73997L0.361218 2.02465C0.157021 1.83063 0.0286086 1.55182 0.00423118 1.24957C-0.0201462 0.947313 0.061508 0.646366 0.231231 0.412933C0.400953 0.179501 0.644841 0.0327044 0.909243 0.00483657C1.17364 -0.0230312 1.4369 0.0703135 1.6411 0.264335L7.00059 5.37383L12.3601 0.435795C12.5069 0.296018 12.6856 0.207228 12.8751 0.179933C13.0646 0.152637 13.257 0.187977 13.4296 0.281772C13.6021 0.375567 13.7475 0.523891 13.8485 0.709193C13.9496 0.894495 14.0022 1.10902 13.9999 1.32738Z' fill='#D9D9D9'/></svg>"));
  });

  $("ul#categories-cls li.nav--has-dropdown span.arrowsubb").on("click", function () {
    $(this).parent("li").hasClass("liactivesubb") == !1
    ? ($("ul#categories-cls li.nav--has-dropdown span.arrowsubb").removeClass("activesubb").siblings("ul").slideUp().parent("li").removeClass("liactivesubb"),
    $(this).addClass("active").siblings("ul").slideDown().parent("li").addClass("liactivesubb"),
    $(this).html("<svg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13.9999 1.32738C14.0004 1.49815 13.9675 1.66688 13.9034 1.82117C13.8394 1.97546 13.746 2.11139 13.63 2.21897L7.63053 7.73997C7.45162 7.90809 7.22719 8 6.99559 8C6.76399 8 6.53957 7.90809 6.36065 7.73997L0.361218 2.02465C0.157021 1.83063 0.0286086 1.55182 0.00423118 1.24957C-0.0201462 0.947313 0.061508 0.646366 0.231231 0.412933C0.400953 0.179501 0.644841 0.0327044 0.909243 0.00483657C1.17364 -0.0230312 1.4369 0.0703135 1.6411 0.264335L7.00059 5.37383L12.3601 0.435795C12.5069 0.296018 12.6856 0.207228 12.8751 0.179933C13.0646 0.152637 13.257 0.187977 13.4296 0.281772C13.6021 0.375567 13.7475 0.523891 13.8485 0.709193C13.9496 0.894495 14.0022 1.10902 13.9999 1.32738Z' fill='#D9D9D9'/></svg>"))
    : ($("ul#categories-cls li.nav--has-dropdown span.arrowsubb").removeClass("activesubb").siblings("ul").slideUp().parent("li").removeClass("liactivesubb"), $(this).html("<svg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13.9999 6.67262C14.0004 6.50185 13.9675 6.33312 13.9034 6.17883C13.8394 6.02454 13.746 5.88861 13.63 5.78103L7.63053 0.260033C7.45162 0.0919093 7.22719 -9.28495e-08 6.99559 -8.9874e-08C6.76399 -8.68986e-08 6.53957 0.0919093 6.36065 0.260033L0.361218 5.97535C0.157021 6.16937 0.0286086 6.44818 0.00423118 6.75043C-0.0201462 7.05269 0.061508 7.35363 0.231231 7.58707C0.400953 7.8205 0.644841 7.9673 0.909243 7.99516C1.17364 8.02303 1.4369 7.92969 1.6411 7.73566L7.00059 2.62617L12.3601 7.5642C12.5069 7.70398 12.6856 7.79277 12.8751 7.82007C13.0646 7.84736 13.257 7.81202 13.4296 7.71823C13.6021 7.62443 13.7475 7.47611 13.8485 7.29081C13.9496 7.1055 14.0022 6.89098 13.9999 6.67262Z' fill='#D9D9D9'/></svg>"));
  });

  // product page swatch change
  $('input.custom_swatch').click(function(){
    console.log("test swatch click");
    // setTimeout(function() {
      var current_url = window.location.href;
      var current_url_split = current_url.split('?')[1];
      var current_url_split_new = current_url_split.split('=')[1];
      
      $('.colors_variants').each(function(){
        var variants_id = $(this).attr('variants-id');
        if(current_url_split_new == variants_id ) {
          var selected_image = $(this).attr('variant-image');
          var selected_image_new = selected_image.split('/')[6];
          var selected_image_new1 = selected_image_new.split('?')[0];
          $('.custon_images_variants').each(function(){
            var variants_slider_img = $(this).attr('src');
            if(variants_slider_img.includes(selected_image_new1)){
              $(this).trigger('click');
            }
          });
        }
      });
    // }, 500);
  });

  $('fieldset.js.product-form__input.size').find('.custom_swatch').eq(0).trigger("click");
  $('fieldset.js.product-form__input.color').find('.custom_swatch').eq(0).trigger("click");
});

 